export * from './types';
export var createChatbotPocApi = function (baseUrl, http) {
    var answersOrigin;
    try {
        var origin_1 = new URL(baseUrl).origin;
        answersOrigin = origin_1;
    }
    catch (_a) {
        answersOrigin = '';
    }
    var apiUrl = "".concat(answersOrigin, "/apps/chatbot");
    return {
        getFlows: function () {
            return http.get("".concat(apiUrl, "/flows"));
        },
        createFlow: function (name) {
            return http.post("".concat(apiUrl, "/flows"), { name: name });
        },
        updateFlow: function (flow) {
            return http.put("".concat(apiUrl, "/flows/").concat(flow.id), flow);
        },
        removeFlow: function (flowId) {
            return http.delete("".concat(apiUrl, "/flows/").concat(flowId));
        },
        getWidgetDefaultFlow: function (widgetId) {
            return http.get("".concat(apiUrl, "/widgets/").concat(widgetId, "/default"));
        },
        setWidgetDefaultFlow: function (widgetId, flowId) {
            return http.put("".concat(apiUrl, "/widgets/").concat(widgetId, "/default"), { flowId: flowId });
        },
    };
};
//# sourceMappingURL=index.js.map